import { DEFAULT_FONT_INDEX, fontifyString } from '../../../../utils/fonts';
import { IFont, allFonts, FontCategory } from '../../../../data/fonts';
import { FontMetadata, FontData, TextSource } from '../../../../types/text';

const nonFontifiable = [FontCategory.Lettercases, FontCategory.TextArt];

export function addToEditorData(oldData: FontData, text: string, font: IFont): FontData {
  const [oldText, oldMeta] = oldData;
  const newText = oldText + text;
  const newMeta = [...oldMeta, ...new Array(text.length).fill(font.id)];

  return [newText, newMeta, TextSource.COPY];
}

function getFontId(arr: FontMetadata, pos: number) {
  if (pos === 0) {
    return arr[pos + 1] !== undefined ? arr[pos + 1] : DEFAULT_FONT_INDEX;
  }

  return arr[pos - 1];
}

function insertStrAtPosition(oldStr: string, toInsert: string, pos: number) {
  return oldStr.substring(0, pos) + toInsert + oldStr.substring(pos);
}

function tryToFontify(font: IFont, text: string) {
  if (!font || nonFontifiable.includes(font.mainCategory)) {
    return text;
  }

  return fontifyString(font, text) as string;
}

function addCharToMetadata(
  oldMeta: FontMetadata,
  fontIndex: number,
  pos: number,
  len: number,
): FontMetadata {
  const newMetaEntry = new Array(len).fill(fontIndex);

  return [].concat(oldMeta.slice(0, pos), newMetaEntry, oldMeta.slice(pos));
}

export function getDataOnInput(str: string, data: FontData, position: number): [FontData, number] {
  const [text, metadata] = data;
  const id = getFontId(metadata, position);
  const font = allFonts[id];
  const fontified = tryToFontify(font, str);
  const newText = insertStrAtPosition(text, fontified, position);
  const newMetadata = addCharToMetadata(metadata, id, position, fontified.length);

  return [[newText, newMetadata, TextSource.INTERNAL], position + fontified.length];
}

export function getDataOnDelete(newText: string, data: FontData, position: number): FontData {
  const [text, metadata] = data;
  const len = text.length - newText.length;
  const newMetadata = [...metadata];

  newMetadata.splice(position, len);

  return [newText, newMetadata, TextSource.INTERNAL];
}

export function cloneFontData(data: FontData): FontData {
  const [text, metadata, textSource] = data;

  return [text, [...metadata], textSource];
}

export function dataContainesAsciiArt(data: FontData) {
  const [, metadata] = data;

  const found = metadata.find((id) => id >= 156 && id <= 173);

  return Boolean(found);
}
